import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_3 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách tài khoản" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          loading: _ctx.isLoading,
          value: $setup.list,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          rowHover: true,
          filters: $setup.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ($setup.filters = $event)),
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          globalFilterFields: ['fullname','username'],
          currentPageReportTemplate: "Có tổng số {totalRecords} tài khoản",
          columnResizeMode: "fit | expand"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: "Xoá",
                class: "p-button-outlined",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.clearFilter())),
                style: {"width":"6em"}
              }),
              _createVNode("span", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_InputText, {
                  modelValue: $setup.filters['global'].value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.filters['global'].value = $event)),
                  placeholder: "Tìm theo tên hoặc tài khoản"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          paginatorLeft: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi plus-circle",
              class: "p-button-text",
              onClick: _ctx.loadBook
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "fullname",
              header: "Họ và tên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "username",
              header: "Tài khoản",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "team",
              header: "Khoa",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "permission",
              header: "Quyền hạn",
              sortable: ""
            }),
            _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  style: {"text-decoration":"none !important"},
                  to: { name: 'updateUser', params: {id: slotProps.data.id}}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      type: "button",
                      label: "Chỉnh sửa",
                      icon: "pi pi-pencil"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value", "filters"])
      ])
    ]),
    _: 1
  }))
}